// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__2S8ln","Wrapper":"styles_Wrapper__2oCFL","GrayLayer":"styles_GrayLayer__q4XxX"};